<template>
  <div class="meldkamer-settings">
    <form-component ref="form" class="meldkamer-settings-page container" v-if="getEnvironmentConfiguration">
      <div class="row">
        <div class="col">
          <div class="box">
            <div class="row">
              <div class="col">
                <input-component
                    label="Telegram chat ID"
                    v-model="getEnvironmentConfiguration.meldkamerTelegramChatId">
                </input-component>
                <label for="isSmsServiceActivated">SMS berichten service</label>
                <label class="checkbox-container">
                  <input type="checkbox"
                         id="isSmsServiceActivated"
                         v-model="getEnvironmentConfiguration.smsServiceActivated"
                         :checked="getEnvironmentConfiguration.smsServiceActivated">
                  <span class="checkmark"></span>
                </label>
                <p class="successMessage" v-if="showSuccesMessage">{{ succesMessage }}</p>
                <p class="errorMessage" v-if="showErrorMessage">{{ errorMessage }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="box">
            <h4>Bellen bij geen gehoor</h4>
            <div class="add-contacts">
              <div :key="i" v-for="(contact, i) in getEnvironmentConfiguration.contacts">
                <p @click="removeContact(i)">X</p>
                <p v-if="!contactIsValid(contact)" class="errorMessage">{{ contactIsInvalidErrorMessage }}</p>
                <input-component required="required" label="Naam" v-model="contact.contactName"></input-component>
                <input-component required="required" label="Nummer" v-model="contact.phoneNumber"></input-component>
                <hr>
              </div>
              <button
                  ref="addButton"
                  class="add-button"
                  @click="addContact"
              >+</button>
            </div>
          </div>
        </div>
        <button-component
            ref="addButton"
            class="add-button"
            @click.native="createEnvironmentConfiguration">
          Opslaan
        </button-component>
      </div>
    </form-component>
  </div>
</template>

<script>

import InputComponent from '@/components/fields/input.component.vue';
import FormComponent from "@/components/fields/form.component.vue";
import ButtonComponent from "@/components/button.component.vue";
import { mapGetters } from "vuex";
import {isValidPhoneNumber, isValidZipcode, lastContactIsValid} from "@/utils/validators";

export default {
  name: 'admin-meldkamer-settings-page',
  components: {
    InputComponent,
    FormComponent,
    ButtonComponent
  },
  data() {
    return {
      succesMessage: 'Instellingen succesvol opgeslagen!',
      showSuccesMessage: false,
      errorMessage: 'Er is helaas iets fout gegaan tijdens het opslaan.',
      showErrorMessage: false,
      contactIsInvalidErrorMessage: null
    }
  },
  computed: {
    ...mapGetters(['getEnvironmentConfiguration'])
  },
  created() {
    this.$store.dispatch('FETCH_ENVIRONMENT_CONFIG');
  },
  methods: {
    createEnvironmentConfiguration() {
      if (this.validateForm()) {
        this.$store.dispatch('SAVE_ENVIRONMENT_CONFIG', this.getEnvironmentConfiguration)
            .then(response => {
              if (response.status === 201) {
                this.toggleSuccesMessage();
              } else {
                console.error(response);
                this.toggleErrorMessage();
              }
            });
      }
    },
    validateForm: function() {
      !lastContactIsValid(this.getEnvironmentConfiguration.contacts) ? this.contactIsInvalidErrorMessage = 'Contact is niet juist ingevoerd' : this.contactIsInvalidErrorMessage = null;
      return !this.contactIsInvalidErrorMessage;
    },
    toggleSuccesMessage() {
      this.showSuccesMessage = true;
      setTimeout(() => {
        this.showSuccesMessage = false;
      }, 3000);
    },
    toggleErrorMessage() {
      this.showErrorMessage = true;
      setTimeout(() => {
        this.showErrorMessage = false;
      }, 3000);
    },
    contactIsValid: function(contact) {
      return contact.contactName.length > 0 && contact.phoneNumber.length >= 3;
    },
    removeContact(index) {
      this.getEnvironmentConfiguration.contacts.splice(index, 1);
    },
    addContact: function() {
      if (lastContactIsValid(this.getEnvironmentConfiguration.contacts)) {
        this.getEnvironmentConfiguration.contacts.push({
          contactName: '',
          phoneNumber: ''
        });
      }
      console.log(this.getEnvironmentConfiguration)
      // Scroll a bit down so the user can add multiple contacts quickly
      this.$refs.addButton.scrollIntoView();
    },
  }
};
</script>

<style scoped lang="scss">
.row {
  flex-direction: column;

  @include desktop {
    flex-direction: row;
  }
}
.box {
  margin-bottom: 2rem;

  @include desktop {
    background-color: $white;
    padding: 1rem;
    box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
  }

  h4 {
    font-weight: 400;
    margin-bottom: 1rem;
    color: $gray-darkest;
  }
  .errorMessage {
    color: $error;
    font-size: 16px;
  }
  .successMessage {
    color: $primary;
    font-size: 16px;
  }
  p {
    color: $error;
    font-weight: bold;
    margin-bottom: 0px;

    &:hover {
      cursor: pointer;
    }
  }
}

.add-contacts {
  border-radius: 4px;
  border: 1px solid $gray;
  padding: 1rem;
  position: relative;
  margin-bottom: 1rem;

  .add-button {
    $button-size: 42px;
    position: absolute;
    bottom: -($button-size / 2);
    left: 50%;
    margin-left: -($button-size / 2);
    width: $button-size;
    height: $button-size;
    border-radius: 50%;
    background-color: $primary;
    color: $white;
    font-weight: bold;

    &:hover {
      background-color: $lightGreen;
    }
  }
}

</style>
